/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ApiSettings interface.
 */
export function instanceOfApiSettings(value) {
    let isInstance = true;
    isInstance = isInstance && "importBodyData" in value;
    isInstance = isInstance && "importActivities" in value;
    return isInstance;
}
export function ApiSettingsFromJSON(json) {
    return ApiSettingsFromJSONTyped(json, false);
}
export function ApiSettingsFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        importBodyData: json.importBodyData,
        importActivities: json.importActivities,
    };
}
export function ApiSettingsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        importBodyData: value.importBodyData,
        importActivities: value.importActivities,
    };
}
